import update from 'immutability-helper';
import { RootActionTypes } from '../../stores/types';
import { ReadyState } from './constants';
import { ActionTypes as OrganizationActionTypes } from '../organization';
import { LoadingIndicatorState } from './types';

export default function (state = {}, action: RootActionTypes): LoadingIndicatorState {
  switch (action.type) {
    case OrganizationActionTypes.UPDATE_REGION_SETTING_REQUEST:
      return update(state, {
        readyState: { $set: ReadyState.SHOW },
      });
    case OrganizationActionTypes.UPDATE_REGION_SETTING_SUCCESS:
    case OrganizationActionTypes.UPDATE_REGION_SETTING_FAILURE:
      return update(state, {
        readyState: { $set: ReadyState.HIDE },
      });
    default:
      return state;
  }
}
